import classNames from "classnames";
import { observer } from "mobx-react";
import React, { Component, Fragment } from "react";
import { InjectedIntl, injectIntl, IntlProvider } from "react-intl";
import { State } from "../../stores/EntityStores/StateStore";
import { MainStore } from "../../stores/MainStore";
import Label from "../Label";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
  intl: IntlProvider & InjectedIntl;
}

@observer
class CountrySelector extends Component<
  IProps & React.HTMLAttributes<HTMLImageElement>
> {
  getContinentListItems(): JSX.Element[] {
    const { store, intl } = this.props;
    return store.continents.map(continent => (
      <Fragment key={Math.random()}>
        <li
          key={Math.random()}
          onClick={e => {
            if (!continent.disabled) store.selectContinent(continent);
          }}
          className={[
            classes.ContinentListItem,
            continent.disabled ? classes.ListItemDisabled : ""
          ]
            .filter(e => e !== "")
            .join(" ")}
        >
          {continent.disabled && (
            <Label
              extraSmall
              bold
              uppercase
              id={"continent-coming-soon"}
              className={classes.ComingSoon}
            />
          )}
          <Label big bold uppercase text={continent.name} />
        </li>
        {continent.states.map((state: State) => {
          return (
            <li
              key={Math.random()}
              onClick={e => {
                if (!continent.disabled || !state.disabled)
                  store.selectState(state);
              }}
              className={[
                classes.StateListItem,
                state.selected ? classes.StateListItemSelected : "",
                continent.disabled ? classes.ListItemDisabled : "",
                state.disabled ? classes.ListItemDisabled : ""
              ]
                .filter(e => e !== "")
                .join(" ")}
            >
              {state.disabled && (
                <Label
                  extraSmall
                  bold
                  uppercase
                  id={`state-coming-soon-${state.id}`}
                  className={classes.ComingSoon}
                />
              )}
              <Label
                medium
                bold
                text={intl.formatMessage({
                  id: `${state.id}-label`
                })}
              >
                {intl.formatMessage({
                  id: `${state.id}-label`
                })}
              </Label>
            </li>
          );
        })}
      </Fragment>
    ));
  }
  
  getContinentListItemsAsSelect(): JSX.Element[] {
    const res: JSX.Element[] = [];
    const { store, intl } = this.props;
    res.push(

    );
    return [
      <option
        key="first"
        className={classes.ContinentListItem}
        value={""}
      >
        -
      </option>,
      ...store.continents
        .filter(continent => !continent.disabled)
        .map(continent => (
          <Fragment key={Math.random()}>
            <option
              key={Math.random()}
              className={classes.ContinentListItem}
              value={continent.name}
            >
              {continent.name}
            </option>
            {continent.states.map((state: State) => {
              return (
                <option
                  key={Math.random()}
                  className={[
                    classes.StateListItem,
                    state.selected ? classes.StateListItemSelected : ""
                  ]
                    .filter(e => e !== "")
                    .join(" ")}
                  value={state.name}
                >
                  {intl.formatMessage({ id: `${state.id}-label` })}
                </option>
              );
            })}
          </Fragment>
        ))
    ]
  }

  render() {
    const { store } = this.props;
    if (!store) return null;
    const { selectedState, selectedContinent } = store;
    let selectCurrentValue = "";
    if (selectedState || selectedContinent) {
      selectCurrentValue = selectedState
        ? selectedState.name
        : selectedContinent.name;
    }
    const countrySelectorClasses = classNames(
      classes.CountrySelector,
      selectedState ? classes.OnSelectedState : ""
    );
    return (
      <div className={countrySelectorClasses}>
        <ul className={classes.ContinentList}>
          {this.getContinentListItems()}
        </ul>
        <div className={classes.ContinentListAsSelect}>
          <select
            value={selectCurrentValue}
            onChange={e => {
              store.openStateOrContinent(e.target.value);
            }}
          >
            {this.getContinentListItemsAsSelect()}
          </select>
          <div className={classes.Chevron} />
        </div>
      </div>
    );
  }
}
export default injectIntl(CountrySelector);
